'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function authInterceptor($cookieStore) {
	'ngInject';

	var service = {
		request: request
	};

	return service;

	function request(config) {
		var token = $cookieStore.get('token');
		var version = 1;

		config.headers = config.headers || {};
		config.headers.Version = version;
		config.headers.Accept = 'application/json';
		config.headers['Accept-Language'] = localStorage.getItem('lang');

		// Used in waybill
		if (config.url.match(/waybills\//)) {
			config.headers['Accept-Language'] = 'en';
		}

		config.url = transformUrl(config.url, token);
		return config;
	}

	/** */
	function transformUrl(url, token) {
		// Check if the request is for a template
		var templateTest = new RegExp('(http:\/\/)|(https:\/\/)');
		if (!templateTest.test(url)) {
			return url;
		}

		// Check if the token is the first query param or not
		var urlTest = new RegExp('&|\\?');
		if (urlTest.test(url)) {
			return url + '&token=' + token;
		} else {
			return url + '?token=' + token;
		}
	}
}

exports['default'] = authInterceptor;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/auth-interceptor/auth.interceptor.js
 **/